import { Component, OnInit, inject } from '@angular/core'
import { FormBuilder, FormGroup, Validators } from '@angular/forms'

import { Environment } from '@cyborg-monorepo/hunter/common'
import { DialogRef, DialogService, DIALOG_DATA } from '@hyperkit'

import { EnvironmentService } from '../../../../shared/services/environment.service'

@Component({
  standalone: false,
  selector: 'edit-environment-dialog',
  templateUrl: './edit-environment-dialog.component.html',
  styleUrls: ['./edit-environment-dialog.component.scss'],
})
export class EditEnvironmentDialogComponent implements OnInit {
  dialogRef = inject(DialogRef)
  private formBuilder = inject(FormBuilder)
  dialogService = inject(DialogService)
  environmentService = inject(EnvironmentService)
  environment = inject<Environment>(DIALOG_DATA, { optional: true })

  public formGroup: FormGroup
  public error: string

  public ngOnInit(): void {
    this.formGroup = this.formBuilder.group({
      name: ['', Validators.required],
      description: [],
    })
  }

  public onSubmit(): void {
    this.environmentService
      .updateEnvironment(this.environment.id, this.formGroup.value)
      .subscribe(
        (environment: Environment) => {
          this.dialogRef.close(environment)
        },
        (error) => {
          this.error = error.message
        },
      )
  }

  public onClose(): void {
    this.dialogRef.close()
  }
}
